module.exports = __webpack_public_path__ + "static/media/logo.5d5d9eef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/logo.svg
// module id = 226
// module chunks = 0